import React from "react"
import moment from "moment"
import { baseUrlImg } from "../../config/api"
import FallbackTicket from "./FallbackTicket"

const JsonBitnovoTicket = ({ arr }) => {
  if (arr?.service_type === "MrPay") return <FallbackTicket arr={arr}/>

  const data = JSON.parse(arr?.receipt)

  const amount = (data.amountCents / 100).toFixed(2)

  console.log(data)
  return (
    <div className="json_spedizionepro">
      <div className="d-flex justify-content-center" style={{ border: "none" }}>
        <img
          src={`${baseUrlImg}/${arr.logo}`}
          alt="service logo"
          style={{ maxHeight: "60px", marginBottom: "10px" }}
        />
      </div>

      <div style={{ paddingTop: 10 }}>
        <strong>Importo:</strong>{" "}
        <span>
          {amount} {data.currency}
        </span>
      </div>

      <div style={{ paddingTop: 10 }}>
        <strong>Date:</strong>{" "}
        <span>{moment(data.created_at).format("DD/MM/YYYY HH:mm:ss")}</span>
      </div>

      {data.code && (
        <div style={{ paddingTop: 10 }}>
          <strong>Order ID:</strong> <span>{data.code}</span>
        </div>
      )}

      {data.pin && (
        <div style={{ paddingTop: 10 }}>
          <strong>Codice PIN:</strong> <span>{data.pin}</span>
        </div>
      )}
    </div>
  )
}

export default JsonBitnovoTicket
